import { Capacitor } from "@capacitor/core";

/** Mobile bundle (Capacitor iOS/Android) — set at build time via REACT_APP_BUILD_TARGET. */
export const IS_MOBILE_BUILD = process.env.REACT_APP_BUILD_TARGET === "mobile";

/** True when running inside the Capacitor native app (App Store / Play Store). */
export function isNativeCapacitorApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return typeof window !== "undefined" && !!window.Capacitor;
  }
}

/** True on iOS Simulator (no camera hardware). Used to route Take Photo → photo library. */
export function isLikelyIosSimulator() {
  if (!isNativeCapacitorApp()) return false;
  try {
    if (Capacitor.getPlatform() !== "ios") return false;
  } catch {
    return false;
  }
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  // Simulator WebViews often include "Simulator" or run on Mac host with Mobile token.
  return /Simulator/i.test(ua) || (/Mac OS X/i.test(ua) && /Mobile/i.test(ua));
}

/** Team selfie should use native camera/photo library, not HTML file input. */
export function shouldUseNativeSelfiePicker() {
  return IS_MOBILE_BUILD || isNativeCapacitorApp();
}

/** PWA (Add to Home Screen) shows phone setup tips; native app does not. */
export function shouldShowPhoneSetupTips() {
  return !isNativeCapacitorApp();
}
